import { dialog } from "../../../../nq-component";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import DialogModal from "../../../../components/Dialog";
import {
  computePartialCosts,
  computeTotalCost,
} from "../../../../componentCostUtils";

class PackagingBreakdownFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    // Preserve raw_materials if present in the view
    if (!this.object.raw_materials && this.view.state.object?.raw_materials) {
      this.object.raw_materials = [...this.view.state.object.raw_materials];
    }

    this.view.setObject(this.object);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = { include: ["raw_materials", "raw_materials.uom", "uom"] };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async save() {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();

    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    const rawMaterials = computePartialCosts(
      this.view.state.object.raw_materials || []
    );
    this.change.raw_materials = rawMaterials;
    this.change.cost = computeTotalCost(rawMaterials);
    // this.change.storeId = { id: user.storeAnalytic[0]?.id };
    console.log("save", this.change);

    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.change = {};
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    // if (Object.values(this.change).length === 0) {
    //   this.view.showSuccessSnackbar("Successfully saved!");
    //   return;
    // }
    try {
      this.view.submitting();
      dialog.close();
      await this.save();

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default PackagingBreakdownFormPresenter;
